<script>

  export let src
  export let srcset = null
  export let caption = ""
  export let credits = null
  export let title = credits || caption
  export let alt = caption
  export let almanac = false

</script>

<figure {title}>
  <div class="imgwrapper">
    <img {src} {alt} {srcset} loading="lazy">
  </div>
  {#if caption || credits}
    <figcaption class:almanac>
      {#if caption}
        {caption}
      {/if}
      {#if credits}
        <div class="credits">
          {credits}
        </div>
      {/if}
    </figcaption>
  {/if}
</figure>

<style lang="scss">
  figure {
    //border: solid 1px white;
    margin: 0 60px;
    @include media-small {
      margin: 0;
    }
  }

  .imgwrapper {
    max-width: 100%;
    //border: solid 1px red;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  img {
    max-width: 100%;
    max-height: 70vh;

    border-radius: 20px;
    @include media-small {
      border-radius: 15px;
    }
  }

  figcaption {
    text-align: center;
    @include typo-grotesk-title-captions-20;
    &.almanac {
      @include typo-serif-caption-18;
    }

    padding: 5px 40px 0 40px;
    @include media-small {
      padding: 5px 20px 0 20px;
    }
  }

</style>
